// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2MXVC","bigColWidth":"Table_bigColWidth__AQl9d","biggerColWidth":"Table_biggerColWidth__2SPWY","row":"Table_row__3zhZ9","col":"Table_col__1UGs5"};